import React, { useState } from 'react'
import {
	CImg, CImage, CCardHeader,
	CButton,
	CCol, CRow,
	CInput, CFormInput, CForm, CModal,
	CModalHeader, CModalBody,
	CDropdown, CCard, CCardTitle,
	CFormGroup, CFormLabel,
} from 'compat/coreui';
// import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { toast } from 'react-toastify';

function usePersistentState(init) {
	const [value, setValue] = React.useState(
		JSON.parse(localStorage.getItem('myProduct')) || init
	)
	React.useEffect(() => {
		localStorage.setItem('myProduct', JSON.stringify(value))
	})
	return [value, setValue]
}

export default function BusinessMenu({ seller }) {
	const [orderPrice, setOrderPrice] = useState("priceEight");
	const [modal, setModal] = useState(false);
	const [orderProduct, setOrderProduct] = useState({});
	const [cartItems, setCartItems] = usePersistentState([]);
	const items = useSelector(state => state.products)
	const dispatch = useDispatch()
	const [compCard, setCompCard] = useState('dashboard');
	const [cartData, setCartData] = useState([])
	const mytoken = localStorage.getItem('token');
	const orderDetails = localStorage.getItem('myProduct');
	const modalToggle = (product) => {
		setModal(!modal);
		setOrderProduct(product);
	}

	const orderHandler = (product, priceType) => {
		// e.preventDefault();
		// const token = localStorage.getItem('token');
		setOrderProduct(product);
		setModal(false);
		setOrderPrice(priceType)
		console.log("orderPrice=> ", orderPrice, priceType, product);
		let dataArray = items.slice();
		// "category": orderProduct.category,
		let founded = dataArray.find(e => e.productId + "" == product._id + "")
		dataArray.map(e => {
			if (e.productId + "" == product._id + "") e.quantity = e.quantity + 1;
			return e;
		})
		let totalItemsPrice = 0;
		if (founded) totalItemsPrice = founded.totalOrderPrice;
		if (priceType == "priceHalf") {
			totalItemsPrice = parseFloat(totalItemsPrice) + parseFloat(product.priceHalf)
		} else if (priceType == "priceForth") {
			totalItemsPrice = parseFloat(totalItemsPrice) + parseFloat(product.priceForth)
		} else if (priceType == "priceEight") {
			totalItemsPrice = parseFloat(totalItemsPrice) + parseFloat(product.priceEight)
		} else if (priceType == "priceOz") {
			totalItemsPrice = parseFloat(totalItemsPrice) + parseFloat(product.priceOz)
		} else if (priceType == "price") {
			totalItemsPrice = parseFloat(totalItemsPrice) + parseFloat(product.price)
		}
		const data = {
			"productId": product._id,
			"priceType": priceType,
			"preOrder": 1,
			"quantity": 1,
			"totalOrderPrice": totalItemsPrice,
			productDetails: product,
		}
		if (!founded)
			dataArray.push(data);
		else {
			founded.totalOrderPrice = totalItemsPrice;
		}
		setCartItems(dataArray);
		dispatch({ type: 'UPDATE_PRODUCT', data: dataArray })
		dataArray = dataArray.reverse();
		const newData = JSON.stringify(dataArray)
		localStorage.setItem('myProduct', newData);
	}
	let saveditems = useSelector(state => state.products)

	const getItemCount = id => {
		return seller.products.filter(p => p.category === id).length
	}
	let totalPrice = 0
	if (saveditems.length > 0) {
		saveditems.map(item => {
			let p = item.productDetails[item.priceType]
			totalPrice = item.totalOrderPrice
		})
	}
	const removeItem = (id) => {
		let arr = [...saveditems];
		arr.splice(id, 1);
		setCartData(arr);
		if (arr.length === 0) {
			dispatch({ type: 'UPDATE_PRODUCT', data: arr })
			localStorage.setItem('myproduct', '[]');
		} else {
			dispatch({ type: 'UPDATE_PRODUCT', data: arr })
			const newData = JSON.stringify(arr)
			localStorage.setItem('myProduct', newData);
		}
	}
	const goBack = () => {
		window.history.back();
	}
	const placeOrder = (e) => {
		e.preventDefault();
		let cdata = cartData.slice().map(product => {
			product.productDetails = undefined
			return product
		});

		axios({
			url: `${process.env.REACT_APP_APP_API_URL}/api/order`,
			method: 'POST',
			headers: {
				'Authorization': 'Bearer ' + mytoken
			},
			data: {
				products: cdata
			}
		}).then(response => {
			if (response.data.status) {
				localStorage.removeItem('myProduct');
				setCartData([]);
				toast.success('Ordered successfully');
			}
		}).catch(console.log)
	}
	const isThere = prod => {
		return items.filter(item => item.productId === prod._id).length > 0
	}
	return (
		<div>
			<CCard className="profile_content business-dashboard">
				<CCardHeader className="category_header">
					<span style={{ fontSize: "18px" }}>Menu & Products</span>
					<div>
						<CForm inline>
							<CFormInput
								className="mr-sm-2"
								placeholder="Search"
								size="sm"
							/>
						</CForm>
						<Link to="/cart"><span>Go To Cart</span></Link>
					</div>
				</CCardHeader>
				{(seller && seller.menus) ? <CRow><CCol className="text-center m-4"></CCol></CRow>
					: <CRow className="mt-5 price_heading">
						<CCol lg={5} />
						<CCol lg={1}>g</CCol>
						<CCol lg={1}>1/8</CCol>
						<CCol lg={1}>1/4</CCol>
						<CCol lg={1}>1/2</CCol>
						<CCol lg={1}>oz</CCol>
						<CCol lg={2} />
					</CRow>}
				{(seller && seller.menus) && seller.menus.map((item, i) =>
				(<div key={i} className="biz_module biz_menu c_12 doaj">
					<h2 style={{ padding: "10px" }}>{item.title}</h2>
					{seller.products.filter(p => p.category === item._id).map((product, j) =>
						// <div style={{ border: "1px solid #d2c7c7", margin: "20px", margin: "20px" }}>
						// 	<CRow key={j} style={{ padding: '0px 22px', alignItems: "center" }}>
						// 		<CCol onClick={() => modalToggle(product)} lg={2} className="menu_headline d-flex" style={{ padding:"0",margin:"0",borderRight:"1px solid #eee",overflow: "hidden",width: "inherit"}} >
						// 			<CImg style={{ width: "100%",transform: "scale(1.2)" }} src="/images/indica.jpg" className="rounded-circle menu-icon" alt="Indica" />
						// 		</CCol>
						// 		<div className="" style={{ width:"80%"}}>
						// 		<CCol onClick={() => modalToggle(product)} lg={1} sm={1} className="menu-price dashed-border" style={{ marginLeft: "30px" }} ><h4>{product.price}</h4><span>g</span><div className="plus"><span> + </span></div></CCol>
						// 		<CCol onClick={() => modalToggle(product)} lg={1} sm={1} className="menu-price dashed-border"><h6>{product.priceEight}</h6><span>1/8 oz</span><div className="plus"><span> + </span></div></CCol>
						// 		<CCol onClick={() => modalToggle(product)} lg={1} sm={1} className="menu-price dashed-border"><h6>{product.priceForth}</h6><span>1/4 oz</span><div className="plus"><span> + </span></div></CCol>
						// 		<CCol onClick={() => modalToggle(product)} lg={1} sm={1} className="menu-price dashed-border"><h6>{product.priceHalf}</h6><span>1/2 oz</span><div className="plus"><span> + </span></div></CCol>
						// 		<CCol onClick={() => modalToggle(product)} lg={1} sm={1} className="menu-price dashed-border"><h6>{product.priceOz}</h6><span>oz</span><div className="plus"><span> + </span></div></CCol>
						// 		<CCol onClick={() => modalToggle(product)} lg={2} sm={1} className="menu-price">
						// 			{/* {(!isThere(product)) && <CButton color="warning" className="text-white" onClick={() => modalToggle(product)}>Add to cart</CButton>} */}
						// 			<CButton color="warning" className="text-white" onClick={() => modalToggle(product)}>Add to cart</CButton>
						// 		</CCol>
						// 		</div>
						// 	</CRow>
						// </div>
						<div className="row item_row">
							<div className="img_div">
								<img style={{ width: "100%", transform: "scale(1.1)" }} src="/images/indica.jpg" />
							</div>
							<div style={{ width: "80%" }}>
								<h4 style={{ marginLeft: "6px" }}>{product.name}</h4>
								<div className="second_col" style={{ display: "flex" }}>
									<div className="custon_box" onClick={() => orderHandler(product, "price")}>
										<h4>${product.price}</h4>
										<span>g</span>
										<div className="plus"><span> + </span></div>
									</div>
									<div className="custon_box" onClick={() => orderHandler(product, "priceEight")}>
										<h4>${product.priceEight}</h4>
										<span>1/8 oz</span>
										<div className="plus"><span> + </span></div>
									</div>
									<div className="custon_box" onClick={() => orderHandler(product, "priceForth")}>
										<h4>{product.priceForth}</h4>
										<span>1/4 oz</span>
										<div className="plus"><span> + </span></div>
									</div>
									<div className="custon_box" onClick={() => orderHandler(product, "priceHalf")}>
										<h4>{product.priceHalf}</h4>
										<span>1/2 oz</span>
										<div className="plus"><span> + </span></div>
									</div>
									<div className="custon_box" onClick={() => orderHandler(product, "priceOz")}>
										<h4>{product.priceOz}</h4>
										<span>oz</span>
										<div className="plus"><span> + </span></div>
									</div>
								</div>
							</div>
						</div>
					)}
				</div>))}
			</CCard>
			<CModal
				show={modal}
				onClose={modalToggle}
			>
				<CModalHeader closeButton className="text-white" style={{ background: "#FF5F1F" }}>Add To Cart</CModalHeader>
				{(orderProduct) && <CModalBody>
					<CCardTitle>
						<p style={{ color: "#FF5F1F", border: "2px solid #FF5F1F", borderRadius: "5px" }}>A valid Medical card / ID will be verified before fulfilling this order.</p>
						<CCol className="mt-4 mb-4">{orderProduct.name}</CCol>
					</CCardTitle>
					<form className="modal__add-to-cart">
						<CFormGroup className="d-flex">
							<CCol xl={6} className="pr-0">
								<CFormLabel htmlFor="nf-title">Order</CFormLabel>
								<CDropdown className="btn-lg" style={{ padding: '0px' }}>
									<select className="custom-select my-1 mr-sm-2 product_status" onChange={(e) => setOrderPrice(e.target.value)}>
										<option value={`priceEight`}>1/8 - ${orderProduct.priceEight}</option>
										<option value={`priceForth`}>1/4 - ${orderProduct.priceForth}</option>
										<option value={`priceHalf`}>1/2 - ${orderProduct.priceHalf}</option>
										<option value={`priceOz`}>oz - ${orderProduct.priceOz}</option>
										<option value={`price`}>g - ${orderProduct.price}</option>
									</select>
								</CDropdown>
							</CCol>
							<CCol xl={6} className="pr-0">
								<CFormLabel htmlFor="nf-subtitle">Product Type</CFormLabel>
								<h3>Recreational</h3>
							</CCol>
						</CFormGroup>
						<CCol className="mt-5">
							<CButton color="success" type="submit" onClick={orderHandler}>Add To Cart</CButton>{' '}
							<CButton
								color="secondary"
								className="pl-5 pr-5"
								onClick={modalToggle}>
								Cancel
										</CButton>
						</CCol>
					</form>
				</CModalBody>}
			</CModal>
			<CCol lg={10} className="cart-section cart-section-margins">
				<div className="table-responsive cart-section-table">
					{(saveditems.length > 0) ? <table style={{ width: '100%' }}>
						<thead>
							<tr>
								<th>Your Items</th>
							</tr>
						</thead>
						<tbody>
							{saveditems.map((item, index) => {
								return (<tr key={index}>
									<td>
										<span style={{ width: '100%', color: 'green' }}>{item.productDetails !== undefined ? item.productDetails.name : ""}</span>
										<span className="price-type"> {item.quantity} </span>
										<span className="price-type">
											{item.priceType === "priceHalf" ? 'half'
												: item.priceType === "priceEight" ? 'eight'
													: item.priceType === "priceForth" ? 'forth'
														: item.priceType === "priceOz" ? 'oz'
															: "gram"
											}
										</span>
										<span className="price-type p-type">
											{item.quantity}x${item.totalOrderPrice}
										</span>
										<span onClick={() => removeItem(index)}><i className="fa fa-times-circle"></i></span>
									</td>

								</tr>)
							}
							)}
							<tr>
								<td className="pt-5"><span style={{ width: '90px' }}>SubTotal</span> <span>${totalPrice}</span></td>
							</tr>
							<tr>
								<td><span style={{ width: '90px' }}>Tax</span> <span>included</span></td>
							</tr>
							<tr>
								<td><span style={{ width: '90px' }}>Total</span> <span>${totalPrice}</span></td>
							</tr>
						</tbody>
					</table> :
						<table>
							<tbody>
								<tr>
									<td>
										Your cart is empty
                                </td>
								</tr>
							</tbody>
						</table>
					}
				</div>
				{(items.length > 0) && <CButton color="success" className="mt-5" onClick={placeOrder}>PLACE ORDER</CButton>}
				<CButton color="success" className="mt-5" style={{ marginLeft: "10px" }} onClick={goBack} >Add More</CButton>
			</CCol>
		</div>
	)
}